var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlutter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 173,
    viewBox: "0 0 132 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_530_11079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4498 90.0635L14.667 68.8557L78.9014 0H118.462M118.462 63.5398H78.9014L64.0825 79.4262L83.8653 100.634",
    fill: "#5C8DBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1797 121.318L78.2446 136.817H118.462L83.2909 100.634",
    fill: "#1A4674"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 100.637L63.7436 79.1504L83.4872 100.631L63.7436 122.118L44 100.637Z",
    fill: "#456E96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1797 121.47L83.9699 100.634L86.872 103.542L66.0818 124.379L63.1797 121.47Z",
    fill: "url(#paint0_linear_530_11079)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1797 122.117L93.6412 111.105L83.7101 100.634",
    fill: "url(#paint1_linear_530_11079)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2758 156.272V158.048H34.0038V163.688H39.9078V165.464H34.0038V173H31.8198V156.272H41.2758ZM46.0975 155.24V173H43.9135V155.24H46.0975ZM61.4838 159.848V173H59.2998V171.056C58.8838 171.728 58.2998 172.256 57.5478 172.64C56.8118 173.008 55.9958 173.192 55.0998 173.192C54.0758 173.192 53.1558 172.984 52.3398 172.568C51.5238 172.136 50.8758 171.496 50.3958 170.648C49.9318 169.8 49.6998 168.768 49.6998 167.552V159.848H51.8598V167.264C51.8598 168.56 52.1878 169.56 52.8438 170.264C53.4998 170.952 54.3958 171.296 55.5318 171.296C56.6998 171.296 57.6198 170.936 58.2918 170.216C58.9638 169.496 59.2998 168.448 59.2998 167.072V159.848H61.4838ZM67.8353 161.648V169.4C67.8353 170.04 67.9713 170.496 68.2433 170.768C68.5153 171.024 68.9873 171.152 69.6593 171.152H71.2673V173H69.2993C68.0833 173 67.1713 172.72 66.5633 172.16C65.9553 171.6 65.6513 170.68 65.6513 169.4V161.648H63.9473V159.848H65.6513V156.536H67.8353V159.848H71.2673V161.648H67.8353ZM76.5775 161.648V169.4C76.5775 170.04 76.7135 170.496 76.9855 170.768C77.2575 171.024 77.7295 171.152 78.4015 171.152H80.0095V173H78.0415C76.8255 173 75.9135 172.72 75.3055 172.16C74.6975 171.6 74.3935 170.68 74.3935 169.4V161.648H72.6895V159.848H74.3935V156.536H76.5775V159.848H80.0095V161.648H76.5775ZM94.6557 165.92C94.6557 166.336 94.6317 166.776 94.5837 167.24H84.0717C84.1517 168.536 84.5917 169.552 85.3917 170.288C86.2077 171.008 87.1917 171.368 88.3437 171.368C89.2877 171.368 90.0717 171.152 90.6957 170.72C91.3357 170.272 91.7837 169.68 92.0397 168.944H94.3917C94.0397 170.208 93.3357 171.24 92.2797 172.04C91.2237 172.824 89.9117 173.216 88.3437 173.216C87.0957 173.216 85.9757 172.936 84.9837 172.376C84.0077 171.816 83.2397 171.024 82.6797 170C82.1197 168.96 81.8397 167.76 81.8397 166.4C81.8397 165.04 82.1117 163.848 82.6557 162.824C83.1997 161.8 83.9597 161.016 84.9357 160.472C85.9277 159.912 87.0637 159.632 88.3437 159.632C89.5917 159.632 90.6957 159.904 91.6557 160.448C92.6157 160.992 93.3517 161.744 93.8637 162.704C94.3917 163.648 94.6557 164.72 94.6557 165.92ZM92.3997 165.464C92.3997 164.632 92.2157 163.92 91.8477 163.328C91.4797 162.72 90.9757 162.264 90.3357 161.96C89.7117 161.64 89.0157 161.48 88.2477 161.48C87.1437 161.48 86.1997 161.832 85.4157 162.536C84.6477 163.24 84.2077 164.216 84.0957 165.464H92.3997ZM99.7225 161.984C100.107 161.232 100.651 160.648 101.355 160.232C102.075 159.816 102.947 159.608 103.971 159.608V161.864H103.395C100.947 161.864 99.7225 163.192 99.7225 165.848V173H97.5385V159.848H99.7225V161.984Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_530_11079",
    x1: 73.5787,
    y1: 111.048,
    x2: 76.4875,
    y2: 113.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#616161",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_530_11079",
    x1: 63.187,
    y1: 111.376,
    x2: 93.648,
    y2: 111.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#616161",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_530_11079"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 173,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutter);
export default __webpack_public_path__ + "static/media/Flutter.5106f0e5a23fcbbca79e380f059b8232.svg";
export { ForwardRef as ReactComponent };